import { render, staticRenderFns } from "./ViolationFormSkeleton.vue?vue&type=template&id=557f621e&scoped=true"
import script from "./ViolationFormSkeleton.vue?vue&type=script&lang=js"
export * from "./ViolationFormSkeleton.vue?vue&type=script&lang=js"
import style0 from "./ViolationFormSkeleton.scss?vue&type=style&index=0&id=557f621e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "557f621e",
  null
  
)

export default component.exports